import { render, staticRenderFns } from "./RegularMessage.vue?vue&type=template&id=687d9c74&"
import script from "./RegularMessage.vue?vue&type=script&lang=js&"
export * from "./RegularMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports